"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Avatar", {
    enumerable: true,
    get: function() {
        return Avatar;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var getSize = function(size) {
    return {
        container: {
            width: size,
            height: size,
            fontSize: "calc(".concat(size, " / 2.5)")
        },
        excessLabel: {
            width: size,
            height: size
        },
        label: {
            fontSize: "calc(".concat(size, " / 2.5)"),
            lineHeight: size !== "100%" ? size : undefined
        }
    };
};
var Avatar = {
    baseStyle: {
        container: {
            backgroundColor: "primary-disabled"
        },
        label: {
            textColor: "text-secondary"
        },
        badge: {
            backgroundColor: "alert-success-default",
            borderColor: "var(--chakra-colors-background-container-card)"
        }
    },
    sizes: {
        xxl: _object_spread_props(_object_spread({}, getSize("8rem")), {
            textStyle: "text-body-display-XL",
            badge: {
                boxSize: "3.375rem"
            }
        }),
        xl: _object_spread_props(_object_spread({}, getSize("6rem")), {
            textStyle: "text-body-display-L",
            badge: {
                boxSize: "2.5rem"
            }
        }),
        l: _object_spread_props(_object_spread({}, getSize("4rem")), {
            textStyle: "text-body-display-S",
            badge: {
                boxSize: "1.75rem"
            }
        }),
        m: _object_spread_props(_object_spread({}, getSize("3rem")), {
            textStyle: "text-body-display-XS",
            badge: {
                boxSize: "1.25rem"
            }
        }),
        s: _object_spread_props(_object_spread({}, getSize("2rem")), {
            textStyle: "font-body-meta-regular",
            badge: {
                boxSize: "0.875rem"
            }
        }),
        xs: _object_spread_props(_object_spread({}, getSize("1.5rem")), {
            textStyle: "font-body-floating-label-medium",
            badge: {
                boxSize: "0.625rem"
            }
        })
    },
    defaultProps: {
        size: "m"
    }
};
